// Copyright (C) 2021 Bystronic Laser AG

export enum Mode {
  Create = 'create',
  Edit = 'edit',
  View = 'view',
}
